import axiosInstance from "../../../../../axiosInstance";
import {
  success,
  error,
  info,
  warning,
} from "../../../../../store/notification/actions";

export async function getNonSaleableReturn(data) {
  info("Loading ...");
  if (data != null) {
    return axiosInstance
      .post("/nonSaleableReturn/getNonSaleableReturns", {
        store_id: data.store_id,
        user_id: data.user_id,
      })
      .then((response) => {
        if (
          response.data.status === "success" &&
          response.data.data.length > 0
        ) {
          success("Records Loaded Successfully");
          return { message: "", hasError: false, data: response.data.data };
        } else {
          warning("No records found !!!");
          return { message: "No records found.", hasError: true, data: "" };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function addNewNonSaleableReturn(data) {
  info("Saving Non Saleable Return ...");
  if (data != null) {
    return axiosInstance
      .post("/nonSaleableReturn/addNonsaleableReturn", {
        store_id: data.store_id,
        user_id: data.user_id,
        partialfull: data.partialfull,
        boxnumber: data.boxnumber,
        barcode: data.barcode,
        loosequantity: data.loose_qty,
        comments: data.comments,
        supplier: data.supplier,
        supplierid: data.supplier_id,
      })
      .then((response) => {
        if (
          response.data.status === "success" &&
          response.data.data.length > 0
        ) {
          success("Record saved successfully");
          return { message: "", hasError: false, data: response.data.data };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function editNonSaleableReturn(data) {
  info("Saving Physical Inventory ...");
  if (data != null) {
    return axiosInstance
      .post("/physicalInventory/editPhysicalInventory", {
        store_id: data.store_id,
        user_id: data.user_id,
        ndc: data.ndc,
        upc: data.upc,
        packs: data.packs.toString(),
        loose_qty: data.looseQty,
        comments: data.comments,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Record updated successfully");
          return { message: "", hasError: false, data: response.data.data };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

// Delete Non Saleable Returns

export const deleteNonSaleableReturn = (data) => {
  info("Deleting Records ...");
  return axiosInstance
    .post("/nonSaleableReturn/deleteNonSaleableReturn", {
      store_id: data.store_id,
      user_id: data.user_id,
      ndc: data.ndc,
      upc: data.upc,
      lot: data.lot,
    })
    .then((response) => {
      if (response.data.status === "success") {
        success("Records deleted successfully");
        return { message: "", hasError: false, data: response.data.data };
      } else {
        error("Could not complete record deletion.");
        return { message: "", hasError: true, data: "" };
      }
    })
    .catch((err) => {
      error(err.response.data.error[0].message);
      return {
        message: err.response.data.error[0].message,
        hasError: true,
        data: "",
      };
    });
};

// Submit Non Saleable Returns

export async function submitNonSaleableReturn(data) {
  info("Submitting Non Saleable Returns ...");
  if (data != null) {
    return axiosInstance
      .post("/nonSaleableReturn/submitNonSaleableReturn", {
        store_id: data.store_id,
        user_id: data.user_id,
      })
      .then((response) => {
        if (response.data.status === "success") {
          success("Records submitted successfully");
          return { message: "", hasError: false, data: response.data.data };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

// Delete Non Saleable Return
export async function DeleteNonSaleableReturnStage(data) {
  if (data) {
    return await axiosInstance
      .post("/nonSaleableReturn/deleteNonSaleableReturnStage", {
        user_id: data.user_id,
        store_id: data.store_id,
      })
      .then((response) => {
        if (response.data.status === "success") {
          success("New session created Successfully");
          if (response.data.data && response.data.data.length > 0) {
            return response.data.data;
          } else {
            return [];
          }
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
      });
  } else {
    error("Internal error occurred");
  }
}

// Update box number in Non Saleable Return
export async function UpdateStageNonSaleableReturn(data) {
  info("Update Non Saleable Returns ...");
  if (data != null) {
    if (!data.boxnumber) {
      error("Box Number can't be empty");
    }
    return await axiosInstance
      .post("/nonSaleableReturn/updateStageNonSaleableReturn", {
        user_id: data.user_id,
        store_id: data.store_id,
        boxnumber: data.boxnumber,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Non Saleable Returns Updated Successfully");
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
      });
  } else {
    error("Internal error occurred");
  }
}

// Update comments against ndc in saleable return table
export async function UpdateCommentsNonSaleableReturn(data) {
  info("Updating Comment...");
  if (data != null) {
    if (!data.comment) {
      error("Comment should not be empty");
      return;
    }
    return await axiosInstance
      .post("/nonSaleableReturn/updateCommentsNonSaleableReturn", {
        user_id: data.user_id,
        store_id: data.store_id,
        ndc: data.ndc,
        comment: data.comment,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success(response.data.data[0].message);
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
      });
  } else {
    error("Internal error occurred");
  }
}

// get comments for a NDC from saleable return table
export async function GetCommentsNonSaleableReturn(data) {
  info("Loading Comment..");
  if (data != null) {
    return await axiosInstance
      .post("/nonSaleableReturn/getCommentsNonSaleableReturn", {
        user_id: data.user_id,
        store_id: data.store_id,
        ndc: data.ndc,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Loaded Comments");
          return response.data.data;
        } else {
          success("No comments Found. Add New");
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
      });
  } else {
    error("Internal error occurred");
  }
}
